export const DATE_REGEX = /^(?:0[1-9]|1[012])(\/)(?:0[1-9]|[12]\d|3[01])\1(?:19|20)\d\d$/
export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
